<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-row style="padding-bottom: 10px;">
      <el-col :span="24">
        <el-col :span="6">
          <el-select @change="dateSelectChange" v-model="firstDate" filterable placeholder="请选择">
            <el-option v-for="item in dateOptions" :key="item.value" :label="item.label" :value="item.value" /> </el-select
        ></el-col>
        <el-col :span="4">
          <el-button v-if="hasPermsFake" type="primary" style="margin-left:5px" @click="settleLogFake">统计数据</el-button>
        </el-col>
      </el-col>
    </el-row>

    <el-table :data="fundSettlefkLogs" resource="fund-settlefk-logs" v-loading="loading">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="cycle_tag" label="盛塘周期" />
      <el-table-column prop="total_bonus" label="总分红" />

      <el-table-column align="center" header-align="center" label="总盒数">
        <template slot-scope="scope"
          >&nbsp;
          <el-tag type="info">{{ parseInt(scope.row.total_bonus_raw / 6.3) }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="董事" width="300">
        <template slot-scope="scope">
          <span>业绩：{{ scope.row.dongshi_num }}</span
          >，&nbsp; <span>人均：{{ scope.row.dongshi_num_rentou }}</span
          >，&nbsp;
          <el-tag type="info" style="cursor: pointer" @click="detailList(1, scope.row)">明细</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="大区" width="300">
        <template slot-scope="scope">
          <span>业绩：{{ scope.row.daqu_num }}</span
          >，&nbsp; <span>人均：{{ scope.row.daqu_num_rentou }}</span
          >，&nbsp;
          <el-tag type="info" style="cursor: pointer" @click="detailList(2, scope.row)">明细</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="联创" width="300">
        <template slot-scope="scope">
          <span>业绩：{{ scope.row.lianchuang_num }}</span
          >，&nbsp; <span>人均：{{ scope.row.lianchuang_num_rentou }}</span
          >，&nbsp;
          <el-tag type="info" style="cursor: pointer" @click="detailList(3, scope.row)">明细</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="分红时间" />

      <el-table-column label="操作" class="loading-area">
        <template #default="{ row, $index }">
          <el-button-group>
            <el-button v-if="hasPermsExport" size="small" @click="exportX(row.id)">导出</el-button>
            <el-popconfirm
              confirm-button-text="好的"
              cancel-button-text="不用了"
              icon="el-icon-info"
              icon-color="red"
              title="是否确认发放？此操作不可撤回。"
              @confirm="settleLogProduce(row.id)"
            >
              <el-button size="small" v-if="row.canSendRefund && hasPermsSend" slot="reference">发放</el-button>
            </el-popconfirm>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog :title="detailTitle" :visible.sync="dialogDetailVisible" append-to-body>
      <el-table :data="detailData">
        <el-table-column label="盛塘分红周期">{{ detailPeriod }}</el-table-column>
        <el-table-column property="realName" label="会员姓名/手机号码" width="200" />
        <el-table-column property="totalRentouBonus" label="人均分红" />
        <el-table-column property="totalYejiBonus" label="业绩分红" />
        <el-table-column label="分红时间">{{ detailDate }}</el-table-column>
      </el-table>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getFundSettlefkLogs, dateList, exportBonusExcel, settleLogFake, settleLogProduce } from '@/api/fund-settlefk-logs'
import RowDestroy from '@c/LzTable/RowDestroy'
import RowToEdit from '@c/LzTable/RowToEdit'
import { downFile } from '@/libs/download-helper'
import { getFirstError, getMessage, can } from '@/libs/utils'
import { Loading } from 'element-ui'

export default {
  name: 'Index',
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      fundSettlefkLogs: [],
      page: null,
      loading: true,
      dateOptions: [],
      firstDate: '',
      dialogDetailVisible: false,
      detailData: [],
      detailTitle: '',
      detailPeriod: '',
      detailDate: '',
      cycle_tag: '',
      hasPermsExport: false,
      hasPermsSend: false,
      hasPermsFake: false,
      query: {},
    }
  },
  created() {
    this.getDateList()
    this.hasPermsExport = can('fund-settlefk-logs.export')
    this.hasPermsSend = can('fund-settlefk-logs.settle-log-produce')
    this.hasPermsFake = can('fund-settlefk-logs.settle-log-fake')
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData()
      },
      immediate: true,
    },
  },
  methods: {
    async getDateList() {
      const { data } = await dateList()
      this.dateOptions = data
      this.firstDate = data[0].value
      this.cycle_tag = this.firstDate
    },
    async loadData() {
      const {
        data: { data, meta },
      } = await getFundSettlefkLogs(this.query)
      this.fundSettlefkLogs = data
      this.page = meta
      this.loading = false
    },
    dateSelectChange(item) {
      console.log(item)
      this.cycle_tag = item
    },
    detailList(type, data) {
      this.detailPeriod = data.cycle_tag
      this.detailDate = data.created_at
      let detailData = []
      this.detailData = []
      if (type == 1) {
        this.detailTitle = '董事分红明细'
        detailData = JSON.parse(data.dongshi_detail)
      } else if (type == 2) {
        this.detailTitle = '大区分红明细'
        detailData = JSON.parse(data.daqu_detail)
      } else if (type == 3) {
        this.detailTitle = '联创分红明细'
        detailData = JSON.parse(data.lianchuang_detail)
      }
      for (let i = 0; i < detailData.length; i++) {
        if (detailData[i].totalRentouBonus == 0 && detailData[i].totalYejiBonus == 0) {
          continue
        }
        this.detailData.push(detailData[i])
      }
      this.dialogDetailVisible = true
    },
    async exportX(id) {
      const loadingInstance = Loading.service()
      const params = {
        type: 'fk',
        id: id,
      }
      const { data } = await exportBonusExcel(params).setConfig({ responseType: 'blob' })
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      downFile(blob, 'fund-settlefk-log.xlsx')
      this.$nextTick(() => {
        loadingInstance.close()
      })
    },
    async settleLogFake() {
      // 分红模拟
      const loadingInstance = Loading.service()
      try {
        const { data } = await settleLogFake({ cycle_tag: this.cycle_tag })
        this.$nextTick(() => {
          loadingInstance.close()
        })
        this.$message.success(data)
        this.loadData()
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
        this.$nextTick(() => {
          loadingInstance.close()
        })
      }
    },
    async settleLogProduce(id) {
      // 基金分红执行
      const loadingInstance = Loading.service()
      try {
        const { data } = await settleLogProduce(id)
        this.$nextTick(() => {
          loadingInstance.close()
        })
        this.$message.success(data)
        this.loadData()
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
        this.$nextTick(() => {
          loadingInstance.close()
        })
      }
    },
  },
}
</script>
